/**
 * Slide-in Filter Sidebar JavaScript - Container Based
 * Works with custom filter toggle button
 */

class FacetsSlideIn {
  constructor() {
    this.container = document.querySelector('.facets-vertical.facets-slide-in');
    if (!this.container) {
      // Try to recover by adding required classes to the nearest page-width wrapper
      const grid = document.querySelector('.facets-grid-container') || document.querySelector('#ProductGridContainer');
      const wrapper = grid ? grid.closest('.page-width') : null;
      if (wrapper) {
        wrapper.classList.add('facets-vertical', 'facets-slide-in');
        this.container = wrapper;
      }
    }
    if (!this.container) return;

    this.init();
  }

  init() {
  // Ensure a close button exists if wrapper is present
  const { facetsWrapper } = this.getElements();
  if (facetsWrapper) this.addCloseButton(facetsWrapper);

  // Bind events (idempotent)
  this.bindEvents();
    
    // Check if filters should be open by default
    this.checkInitialState();
  }

  addCloseButton(facetsWrapper) {
    if (window.innerWidth < 992) return; // desktop only
    if (!facetsWrapper || facetsWrapper.querySelector('.filter-close-button')) return;
    const closeButton = document.createElement('button');
    closeButton.className = 'filter-close-button';
    closeButton.setAttribute('aria-label', 'Close filters');
    closeButton.innerHTML = `
      <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
      <span>Hide Filter</span>
    `;
    
    closeButton.addEventListener('click', () => this.closeFilters());

    facetsWrapper.insertBefore(closeButton, facetsWrapper.firstChild);
    this.closeButton = closeButton;
  }

  bindEvents() {
    if (this._eventsBound) return; // prevent duplicate listeners

    // Delegated click for Filter toggle (survives DOM replacements)
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action="open-filters"], .facets-vertical-sort .custom-filter-toggle');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      
      // On mobile, use our custom Filter button but open Shopify's native drawer
      if (window.innerWidth < 992) {
        const isCustomFilter = !!e.target.closest('.custom-filter-toggle');
        if (isCustomFilter) {
          const summary = document.querySelector('menu-drawer.mobile-facets__wrapper details.mobile-facets__disclosure > summary');
          if (summary) summary.click();
          return;
        }
        return;
      }
      
      // Desktop mode - use slide-in sidebar
      this.toggleFrom(btn);
    });
    
    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen() && window.innerWidth >= 992) {
        this.closeFilters();
      }
    });
    
    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth < 992 && this.isOpen()) {
        this.closeFilters();
      }
    });

    this._eventsBound = true;
  }

  getElements() {
    const container = document.querySelector('.facets-vertical.facets-slide-in');
    const facetsWrapper = container ? container.querySelector('.facets-grid-container .facets-wrapper') : null;
    return { container, facetsWrapper };
  }

  toggleFrom(btn) {
    // Resolve fresh elements each click
    const { container, facetsWrapper } = this.getElements();
    if (!container || !facetsWrapper) return;

    this.container = container;
    // Ensure close button exists in current DOM
    this.addCloseButton(facetsWrapper);

    // Maintain aria on the clicked control
    this._activeButton = btn;
    this.toggleFilters();
  }

  toggleFilters() {
    if (this.isOpen()) {
      this.closeFilters();
    } else {
      this.openFilters();
    }
  }

  openFilters() {
    const { facetsWrapper } = this.getElements();
    this.container.classList.add('filters-open');
    this.container.classList.remove('filters-closing');
    if (this._activeButton) this._activeButton.setAttribute('aria-expanded', 'true');
    
    // Announce to screen readers
    this.announce('Filters opened');
    
    // Focus first focusable element in filters
    setTimeout(() => {
      const firstFocusable = facetsWrapper ? facetsWrapper.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])') : null;
      if (firstFocusable) {
        firstFocusable.focus();
      }
    }, 100);
  }

  closeFilters() {
    if (!this.isOpen()) return;
    this.container.classList.add('filters-closing');
    this.container.classList.remove('filters-open');
    if (this._activeButton) this._activeButton.setAttribute('aria-expanded', 'false');

    const facetsWrapper = this.container.querySelector('.facets-wrapper');
    const onAnimEnd = (e) => {
      if (e.target !== facetsWrapper) return;
      this.container.classList.remove('filters-closing');
      this.container.removeEventListener('animationend', onAnimEnd);
      this.announce('Filters closed');
      if (this._activeButton) this._activeButton.focus();
    };
    if (facetsWrapper) this.container.addEventListener('animationend', onAnimEnd);
  }

  isOpen() {
    return this.container.classList.contains('filters-open');
  }

  checkInitialState() {
    // If there are active filters, optionally open the sidebar by default
    const activeFilters = this.container.querySelectorAll('.active-facets__button');
    if (activeFilters.length > 0 && window.innerWidth >= 992) {
      // Optionally auto-open if filters are active
      // this.openFilters();
    }
  }

  announce(message) {
    const announcement = document.createElement('div');
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'polite');
    announcement.className = 'visually-hidden';
    announcement.textContent = message;
    document.body.appendChild(announcement);
    
    setTimeout(() => {
      document.body.removeChild(announcement);
    }, 1000);
  }
}

// Initialize once when DOM is ready
(function initFacetsSlideIn() {
  const init = () => { window.__FacetsSlideInInstance = window.__FacetsSlideInInstance || new FacetsSlideIn(); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

// Optional: re-init on section render events if present (theme editor or AJAX renders)
document.addEventListener('shopify:section:load', () => { window.__FacetsSlideInInstance = window.__FacetsSlideInInstance || new FacetsSlideIn(); });

